export const environment = {
  production: false,
  enablePfeuCreditApplicationReport: true,
  azureAd: {
    clientId: 'ace9d7dd-4ba2-4e20-acb6-5dc83def8a52',
    authority: 'https://login.microsoftonline.com/6e93a626-8aca-4dc1-9191-ce291b4b75a1',
    redirectUrl: 'https://ccubedev01.rabo.cloud',
    posLogoutUrl: 'https://ccubedev01.rabo.cloud',
  },
  scopes: ['GroupMember.Read.All','User.Read'],
  // Admin group id (users in this group see all applications)
  adminGroupId: '21516683-25ac-4203-b3cf-0924ee44238c',
  // Map connector keys to the Azure AD group IDs that should see them
  connectorGroupMap: {
    AG_DESK: ['c1041074-7df1-40af-afc3-220ef7675f2e'],
    PFEU: ['d3110242-2cab-4db7-80d6-eebd2256333e'],
    VCF: ['d86c4b87-ac4b-4a43-b7f0-94bd62f69489']
  },
  
  apiBaseUrl: 'https://ccubedev01.rabo.cloud/api/v1',
  resourceBatches: function() {
    return `api://${this.azureAd.clientId}/batches`;
  }
};